export const HERO_CHAT_LINES = [
  { role: 'linas', text: 'What would you like to teach me about your business?' },
  { role: 'you', text: "We're closed tomorrow." },
  { role: 'linas', text: 'Done — I added tomorrow as an off day.' },
  {
    role: 'you',
    text: 'If someone asks how long we’ve been in business, tell them the company was founded in 1977.',
  },
  { role: 'linas', text: 'Got it — I saved this in your Business Knowledge.' },
  { role: 'you', text: 'Every new client gets a free intro call.' },
  { role: 'linas', text: 'Saved — I’ll mention the free intro to first-time clients.' },
  { role: 'you', text: 'We open at 10am downtown and 11am at the second location.' },
  { role: 'linas', text: 'Opening hours are set for both locations.' },
  {
    role: 'you',
    text: 'Add our starter kit to Products — $59. No brand name, just the product details.',
  },
  { role: 'linas', text: 'Saved to Products — I’ll use that when customers ask about it.' },
  {
    role: 'you',
    text: 'If they want to book an appointment, collect the service and preferred time and send a request to the team. Don’t confirm it.',
  },
  {
    role: 'linas',
    text: 'Appointment requests go to your team. I won’t confirm a time.',
  },
];
